import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { Button, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from "@fortawesome/pro-light-svg-icons"

export function AddCustomerContainer({ onClick, className }: { onClick: () => void; className: string }) {
    return (
        <>
            <LocalizedStrict id="create-or-edit-price-list-customer-table-title">
                <Typography variant="h6">Customers with access</Typography>
            </LocalizedStrict>
            <LocalizedStrict id="create-or-edit-price-list-customer-button-add-customer">
                <Button
                    onClick={onClick}
                    color="primary"
                    variant="outlined"
                    className={className}
                    startIcon={<FontAwesomeIcon icon={faPlus} />}
                >
                    Add customers
                </Button>
            </LocalizedStrict>
        </>
    )
}
